module.exports = __webpack_public_path__ + "img/product__time.059d3682.svg";